import "./AIAutomationOverlay.scss";

import {
  Chip,
  ChipBackgroundColor,
  ChipSize,
} from "@amzn/stencil-react-components/chip";
import { ThemeMode } from "@amzn/stencil-react-components/context";
import { Col, View } from "@amzn/stencil-react-components/layout";
import { IconPerson } from "@amzn/stencil-react-icons";
import { FormattedMessage } from "react-intl";

import { useAgentProgress } from "@/hooks/useAgentProgress";
import { useThemeMode } from "@/stores/contexts/ThemeModeContext";

import aivaIconSmall from "../../assets/icons/aivaIconSmall.svg";
import aivaIconSmallLight from "../../assets/icons/aivaIconSmall-light.svg";
import TypingIndicator from "../Commons/TypingIndicator";

/**
 * The step's own indicator that Aiva is working, rendered where the step body would be. Kept in the
 * step because it labels the content Aiva is filling in; docked to the screen edge it read as a
 * second, detached banner.
 */
export const AivaStepStatus = (): JSX.Element => {
  const { themeMode } = useThemeMode();
  const { isUserTurn, isProcessing } = useAgentProgress(true);

  return (
    <Col
      gridGap="S400"
      dataTestId="aivaStepStatus"
      className="ai-automation-container"
    >
      <Chip
        size={ChipSize.Small}
        backgroundColor={
          isUserTurn ? ChipBackgroundColor.Green : ChipBackgroundColor.Purple
        }
        dataTestId="aiAutomationChip"
        id="ai-automation-chip"
        icon={
          isUserTurn ? (
            <IconPerson color="color.icon.primary-default" aria-hidden={true} />
          ) : (
            <img
              src={
                themeMode === ThemeMode.Dark
                  ? aivaIconSmallLight
                  : aivaIconSmall
              }
              alt=""
              className="ai-icon-small"
              data-test-id="aivaStepMark"
            />
          )
        }
      >
        <FormattedMessage
          id={
            isUserTurn
              ? "connectVpn-ai-automation-user-turn-notice"
              : "connectVpn-ai-automation-in-progress"
          }
        />
      </Chip>
      {isProcessing && !isUserTurn && (
        <View
          className="ai-automation-spinner"
          dataTestId="aiAutomationSpinner"
        >
          <TypingIndicator size="md" color="dark" />
        </View>
      )}
    </Col>
  );
};
